module.exports = "query ($id: ID!) {\n  Contact(id: $id) {\n    id\n    name\n    avatar\n    email\n  }\n}\n"